<script>
  import ContactHero from '../parts/contactHero.svelte'
  import Footer from '../parts/footer.svelte'

  export let title
</script>

<svelte:head>
  <title>
    {title} - Devanga Sowdeshwari Amman Association of North America (DSAANA)
  </title>
</svelte:head>
<ContactHero />
<Footer />
